import { formatCents, formatPerThousand } from '../../utils/formatMyPlan';
import { MOCK_TOKEN_PACKS, type TokenPack } from '../../constants/tokenPacks';
import { MyPlanSectionCard } from '../MyPlanSectionCard/MyPlanSectionCard';
import styles from './BuyTokensCard.module.css';

interface BuyTokensCardProps {
	onBuy?: (pack: TokenPack) => void;
}

export const BuyTokensCard = ({ onBuy }: BuyTokensCardProps) => {
	const featured = MOCK_TOKEN_PACKS.find((pack) => pack.featured) ?? MOCK_TOKEN_PACKS[0];

	return (
		<MyPlanSectionCard
			title="Comprar tokens de IA"
			subtitle="Pacotes avulsos entram na hora e não expiram enquanto o plano estiver ativo."
		>
			<div className={styles.packsWrap}>
				<div className={styles.packs}>
					{MOCK_TOKEN_PACKS.map((pack) => (
						<article
							key={pack.id}
							className={`${styles.pack} ${pack.featured ? styles.featured : ''}`}
						>
							{pack.featured ? <span className={styles.badge}>Mais escolhido</span> : null}
							<div className={styles.amountBlock}>
								<span className={styles.amount}>{pack.amountLabel}</span>
								<span className={styles.tokensLabel}>tokens</span>
							</div>
							<div className={styles.priceBlock}>
								<span className={styles.price}>{formatCents(pack.priceCents)}</span>
								<span className={styles.perMil}>{formatPerThousand(pack.priceCents, pack.tokens)}</span>
							</div>
						</article>
					))}
				</div>
			</div>
			<div className={styles.footer}>
				<p className={styles.hint}>
					Uma conversa com a Flora usa cerca de 6 mil tokens. Um laudo de solo completo, cerca de
					40 mil.
				</p>
				<button type="button" className={styles.buy} onClick={() => onBuy?.(featured)}>
					Comprar tokens
				</button>
			</div>
		</MyPlanSectionCard>
	);
};
